/**
 * SearchQueryContainer component.
 */
import styled from 'styled-components';
import Screen from '@shared/utils/screen';

/**
 * Styled search query container.
 */
const SearchQueryContainer = styled.div<React.CSSProperties>`
  left: 0;
  position: absolute;
  overflow: hidden;
  top: ${Screen.widthRatio * 315}px;
`;

export default SearchQueryContainer;
